import { render, staticRenderFns } from "./VueSnackbar.vue?vue&type=template&id=406dafab"
import script from "./VueSnackbar.vue?vue&type=script&lang=js"
export * from "./VueSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports